// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function useCitySelected(initialState) {
  var match = React.useState(function () {
        return initialState;
      });
  return [
          match[0],
          match[1]
        ];
}

export {
  useCitySelected ,
}
/* react Not a pure module */
